/* Door Style Index - FNY 02.09.2026 */
(function () {
  'use strict';

  // Kart aciklamasindan filtre etiketleri turetilir (aciklamalar koleksiyon
  // description alanindan gelir: "UV Super Matt · Black · Slab" gibi).
  var PROFILE = [
    { label: 'Slab', test: /\bslab\b/i },
    { label: 'Finger Pull', test: /finger pull|j-pull/i },
    { label: 'Shaker', test: /shaker/i }
  ];
  var SURFACE = [
    { label: 'Textured', test: /woodgrain|tfl texture|textured/i },
    { label: 'High Gloss', test: /high gloss/i },
    { label: 'Super Matt', test: /super matt/i },
    { label: 'Painted', test: /painted/i }
  ];

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (txt !== null && txt !== undefined) { n.textContent = txt; }
    return n;
  }

  function DSI(root) {
    this.root = root;
    this.grid = root.querySelector('[data-dsi-grid]');
    this.items = [].slice.call(root.querySelectorAll('[data-dsi-item]'));
    this.filtersEl = root.querySelector('[data-dsi-filters]');
    this.statsEl = root.querySelector('[data-dsi-stats]');
    this.resultEl = root.querySelector('[data-dsi-result]');
    this.clearEl = root.querySelector('[data-dsi-clear]');
    this.noResEl = root.querySelector('[data-dsi-noresult]');
    this.headingEl = root.querySelector('[data-dsi-heading]');
    this.baseHeading = this.headingEl ? this.headingEl.textContent.trim() : 'All Door Styles';
    this.cfg = {};
    try {
      var cfgEl = root.querySelector('[data-dsi-config]');
      if (cfgEl) { this.cfg = JSON.parse(cfgEl.textContent); }
    } catch (e) { this.cfg = {}; }
    this.sel = { series: null, profile: null, surface: null };
    if (!this.items.length) { return; }
    this.tag();
    this.stats();
    this.buildChips();
    // URL'den on secim: /pages/all-door-styles?series=express
    // Anasayfadaki Featured Collections kutulari buraya boyle baglaniyor.
    var pre = this.fromUrl();
    this.apply();
    if (pre) { this.reveal(); }
  }

  /* URL parametrelerini gercek filtre degerleriyle esler.
     Buyuk/kucuk harf ve tire/bosluk farkina duyarsiz:
     ?series=express, ?surface=high-gloss, ?profile=finger%20pull */
  DSI.prototype.fromUrl = function () {
    var self = this;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return false; }
    var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var found = false;
    ['series', 'profile', 'surface'].forEach(function (group) {
      var raw = q.get(group);
      if (!raw) { return; }
      // Virgulle ayrilmis coklu deger: ?surface=high-gloss,super-matt
      // "Gloss & Matt" gibi iki yuzeyi kapsayan gruplar tek degerle
      // ifade edilemiyordu. Tek deger davranisi aynen korunuyor.
      var istenen = String(raw).split(',').map(norm).filter(Boolean);
      var hits = [];
      self.values(group).forEach(function (v) { if (istenen.indexOf(norm(v)) !== -1) { hits.push(v); } });
      if (hits.length === 1) { self.sel[group] = hits[0]; found = true; }
      else if (hits.length > 1) { self.sel[group] = hits; found = true; }
    });
    return found;
  };

  /* Secim URL'ye yazilir: link paylasilabilir ve geri tusu calisir. */
  DSI.prototype.pushUrl = function () {
    if (!window.history || !history.replaceState) { return; }
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var self = this;
    ['series', 'profile', 'surface'].forEach(function (group) {
      var s = self.sel[group];
      if (s) {
        var arr = (Object.prototype.toString.call(s) === '[object Array]') ? s : [s];
        q.set(group, arr.map(function (x) { return String(x).toLowerCase().replace(/\s+/g, '-'); }).join(','));
      }
      else { q['delete'](group); }
    });
    var s = q.toString();
    history.replaceState(null, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash);
  };

  /* On secimle gelindiginde filtre satirini gorunur yap. */
  DSI.prototype.reveal = function () {
    var t = this.filtersEl || this.grid;
    if (!t) { return; }
    var run = function () {
      var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
    };
    if ('requestAnimationFrame' in window) { requestAnimationFrame(function () { setTimeout(run, 220); }); }
    else { setTimeout(run, 220); }
  };

  DSI.prototype.tag = function () {
    this.items.forEach(function (it) {
      var d = (it.getAttribute('data-desc') || '') + ' ' + (it.getAttribute('data-name') || '');
      var prof = [], surf = [];
      PROFILE.forEach(function (p) { if (p.test.test(d)) { prof.push(p.label); } });
      SURFACE.forEach(function (s) { if (s.test.test(d)) { surf.push(s.label); } });
      it.setAttribute('data-profile', prof.join('|'));
      it.setAttribute('data-surface', surf.join('|'));
    });
  };

  DSI.prototype.stats = function () {
    if (!this.statsEl) { return; }
    var total = 0;
    this.items.forEach(function (it) { total += parseInt(it.getAttribute('data-count'), 10) || 0; });
    this.statsEl.innerHTML = '';
    var mk = function (n, l) {
      var b = el('div', 'dsi-stat');
      b.appendChild(el('span', 'dsi-stat__n', n));
      b.appendChild(el('span', 'dsi-stat__l', l));
      return b;
    };
    this.statsEl.appendChild(mk(String(this.items.length), 'door finishes'));
    this.statsEl.appendChild(mk(total.toLocaleString('en-US'), 'cabinets & parts'));
  };

  DSI.prototype.values = function (group) {
    var attr = group === 'series' ? 'data-series' : ('data-' + group);
    var seen = [], out = [];
    this.items.forEach(function (it) {
      (it.getAttribute(attr) || '').split('|').forEach(function (v) {
        if (v && seen.indexOf(v) === -1) { seen.push(v); out.push(v); }
      });
    });
    return out;
  };

  DSI.prototype.countFor = function (group, value) {
    var self = this;
    var probe = { series: this.sel.series, profile: this.sel.profile, surface: this.sel.surface };
    probe[group] = value;
    var n = 0;
    this.items.forEach(function (it) { if (self.match(it, probe)) { n++; } });
    return n;
  };

  DSI.prototype.match = function (it, sel) {
    var has = function (attr, v) {
      if (!v) { return true; }
      var sahip = (it.getAttribute(attr) || '').split('|');
      if (Object.prototype.toString.call(v) === '[object Array]') {
        for (var i = 0; i < v.length; i++) { if (sahip.indexOf(v[i]) !== -1) { return true; } }
        return false;
      }
      return sahip.indexOf(v) !== -1;
    };
    return has('data-series', sel.series) && has('data-profile', sel.profile) && has('data-surface', sel.surface);
  };

  DSI.prototype.buildChips = function () {
    var self = this;
    if (!this.filtersEl) { return; }
    this.filtersEl.hidden = false;
    ['series', 'profile', 'surface'].forEach(function (group) {
      var box = self.filtersEl.querySelector('[data-dsi-chips="' + group + '"]');
      if (!box) { return; }
      var vals = self.values(group);
      var row = box.closest('.dsi-filters__row');
      if (vals.length < 2) { if (row) { row.hidden = true; } return; }
      box.innerHTML = '';
      vals.forEach(function (v) {
        // Chip'ler <button> degil <a href>: Googlebot filtre URL'lerini
        // ancak gercek link uzerinden kesfedebilir. Normal tik JS ile
        // yakalanip sayfa yenilenmeden filtreleniyor; orta tik / yeni
        // sekmede ac / bagi kopyala tarayici davranisi korunuyor.
        var b = el('a', 'dsi-chip');
        b.setAttribute('data-v', v);
        b.setAttribute('data-g', group);
        b.appendChild(el('span', null, v));
        b.appendChild(el('span', 'dsi-chip__n', ''));
        b.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) { return; }
          e.preventDefault();
          if (b.getAttribute('aria-disabled') === 'true') { return; }
          self.sel[group] = (self.sel[group] === v) ? null : v;
          self.apply();
        });
        box.appendChild(b);
      });
    });
  };

  /* Bir chip'e tiklandiginda gidilecek URL. Aktif chip'e tiklamak onu
     kaldirir, o yuzden href de o durumu yansitir. */
  /* sel[group] tek deger veya dizi olabilir. */
  DSI.prototype.seciliMi = function (group, value) {
    var s = this.sel[group];
    if (!s) { return false; }
    if (Object.prototype.toString.call(s) === '[object Array]') { return s.indexOf(value) !== -1; }
    return s === value;
  };

  DSI.prototype.hrefFor = function (group, value) {
    var next = { series: this.sel.series, profile: this.sel.profile, surface: this.sel.surface };
    next[group] = this.seciliMi(group, value) ? null : value;
    var kodla = function (v) {
      var arr = (Object.prototype.toString.call(v) === '[object Array]') ? v : [v];
      return arr.map(function (x) { return encodeURIComponent(String(x).toLowerCase().replace(/\s+/g, '-')); }).join(',');
    };
    var parts = [];
    ['series', 'profile', 'surface'].forEach(function (g) {
      if (next[g] && (!next[g].length || next[g].length > 0)) { parts.push(g + '=' + kodla(next[g])); }
    });
    return window.location.pathname + (parts.length ? '?' + parts.join('&') : '');
  };

  DSI.prototype.syncChips = function () {
    var self = this;
    ['series', 'profile', 'surface'].forEach(function (group) {
      var box = self.filtersEl && self.filtersEl.querySelector('[data-dsi-chips="' + group + '"]');
      if (!box) { return; }
      [].slice.call(box.querySelectorAll('.dsi-chip')).forEach(function (b) {
        var v = b.getAttribute('data-v');
        var n = self.countFor(group, v);
        var on = self.seciliMi(group, v);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
        b.setAttribute('href', self.hrefFor(group, v));
        var dead = (n === 0 && !on);
        b.setAttribute('aria-disabled', dead ? 'true' : 'false');
        if (dead) { b.setAttribute('tabindex', '-1'); } else { b.removeAttribute('tabindex'); }
        var nEl = b.querySelector('.dsi-chip__n');
        if (nEl) { nEl.textContent = String(n); }
      });
    });
  };

  /* ---- Dinamik baslik ve SEO basligi ----
     Shopify Liquid query parametresini okuyamadigi icin (test edildi:
     request.query_string / request.parameters -> null) bu bilgiler
     sunucuda uretilemiyor. Googlebot JS render ettigi icin H1, <title>,
     meta description ve canonical burada guncelleniyor.

     Etiket sirasi: Seri + Yuzey + Profil, sonuna "Door Styles".
       ?series=express                -> Express Door Styles
       ?series=express&surface=high-gloss -> Express High Gloss Door Styles
       ?profile=slab                  -> Slab Door Styles                */
  DSI.prototype.label = function () {
    var parts = [];
    var yaz = function (v) { return (Object.prototype.toString.call(v) === '[object Array]') ? v.join(' & ') : v; };
    if (this.sel.series) { parts.push(yaz(this.sel.series)); }
    if (this.sel.surface) { parts.push(yaz(this.sel.surface)); }
    if (this.sel.profile) { parts.push(yaz(this.sel.profile)); }
    if (!parts.length) { return this.baseHeading; }
    var suffix = this.cfg.suffix || 'Door Styles';
    return parts.join(' ') + ' ' + suffix;
  };

  DSI.prototype.activeCount = function () {
    var n = 0;
    if (this.sel.series) { n++; }
    if (this.sel.profile) { n++; }
    if (this.sel.surface) { n++; }
    return n;
  };

  DSI.prototype.applyHead = function (shown) {
    var lbl = this.label();
    var active = this.activeCount();

    // H1
    if (this.headingEl && this.headingEl.textContent !== lbl) {
      this.headingEl.textContent = lbl;
    }

    // <title>
    var suffixTitle = this.cfg.titleSuffix || '';
    document.title = lbl + (suffixTitle ? ' ' + suffixTitle : '');

    // meta description
    var tpl = this.cfg.metaTpl || '';
    if (tpl) {
      var desc = tpl.replace(/%label%/g, lbl).replace(/%count%/g, String(shown));
      var m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
      }
      m.setAttribute('content', desc);
    }

    // canonical: whitelist icindeki durumlar kendine, digerleri cipla sayfaya.
    // Shopify'in kendi canonical'i her zaman ciplak sayfayi gosterdigi icin
    // filtreli URL'lerin indekslenebilmesi bu override'a bagli.
    var maxIdx = parseInt(this.cfg.maxIndexed, 10);
    if (isNaN(maxIdx)) { maxIdx = 2; }
    var selfOk = active <= maxIdx && shown > 0;
    var link = document.querySelector('link[rel="canonical"]');
    if (link) {
      var base = window.location.origin + window.location.pathname;
      var qs = [];
      var self2 = this;
      ['series', 'profile', 'surface'].forEach(function (g) {
        if (self2.sel[g]) { qs.push(g + '=' + encodeURIComponent(String(self2.sel[g]).toLowerCase().replace(/\s+/g, '-'))); }
      });
      link.setAttribute('href', selfOk && qs.length ? (base + '?' + qs.join('&')) : base);
    }

    // robots: whitelist disindaki derin kombinasyonlar ince/yinelenen
    // icerik uretir; onlari noindex ama follow birakiyoruz.
    var rob = document.querySelector('meta[name="robots"][data-dsi-robots]');
    if (!selfOk && active > 0) {
      if (!rob) {
        rob = document.createElement('meta');
        rob.setAttribute('name', 'robots');
        rob.setAttribute('data-dsi-robots', '');
        document.head.appendChild(rob);
      }
      rob.setAttribute('content', 'noindex, follow');
    } else if (rob) {
      rob.parentNode.removeChild(rob);
    }
  };

  DSI.prototype.apply = function () {
    var self = this;
    var shown = 0;
    this.items.forEach(function (it) {
      var ok = self.match(it, self.sel);
      it.hidden = !ok;
      if (ok) { shown++; }
    });
    this.syncChips();
    var any = !!(this.sel.series || this.sel.profile || this.sel.surface);
    if (this.clearEl) {
      this.clearEl.hidden = !any;
      if (!this.clearEl._b) {
        this.clearEl._b = true;
        this.clearEl.addEventListener('click', function () {
          self.sel = { series: null, profile: null, surface: null };
          self.apply();
        });
      }
    }
    if (this.resultEl) {
      this.resultEl.textContent = any
        ? (shown + ' of ' + this.items.length + ' finishes')
        : (this.items.length + ' finishes');
    }
    if (this.noResEl) { this.noResEl.hidden = shown !== 0; }
    this.applyHead(shown);
    this.pushUrl();
  };

  function boot() {
    [].slice.call(document.querySelectorAll('[data-door-style-index]')).forEach(function (n) {
      if (n._dsi) { return; }
      n._dsi = new DSI(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
